import {CardStates} from "@/Enums";

enum CardManagerType {
  Customer = 'Customer',
  Issuer = 'Issuer',
  Operator = 'Operator'
}

interface CardManager {
  id: number,
  name: string,
  type: CardManagerType
}

interface Card {
  id: number,
  cardNumber: number,
  reference: null | string | undefined,
  state: string,
  management?: CardManager
}

interface AvailableCardRanges {
  from: number,
  to: number,
}

interface SearchFilterParameters {
  cardState?: CardStates,
  cardNumber?: number,
  managerTypes?: CardManagerType[],
  managerName?: string,
}

interface CardImportResult{
  successfulImports: number,
  failedImports: number,
  incorrectLinesAsCsv: null | string
}

interface ProfipayCardStates {
  number: number,
  isActive: boolean
}

export type {
  AvailableCardRanges,
  Card,
  SearchFilterParameters,
  CardImportResult,
  ProfipayCardStates,
  CardManager
}

export {
  CardManagerType
}
